// extracted by mini-css-extract-plugin
export var active = "_mn-2";
export var recordingDot = "_mn-1";
export var recordingIndicator = "_mn-0";